import { Fragment } from "react";
import Header from "../../components/Header";
import ListContainer from "../../containers/ListContainer";
export default function BoardPage(){
    return(<Fragment>
    <Header />
    <ListContainer />
    </Fragment>);
}